export const stepsToGetOnline = {
  'builder-pick': {
    description: 'Choose editor and update content',
    imageURL: '/s2/vector/website-builder.svg'
  },
  'website-purchase': {
    description: 'Buy website builder and publish',
    imageURL: '/s2/vector/credit-cards.svg'
  },
  'website-purchase-completed': {
    description: 'Publish your website',
    imageURL: '/s2/vector/good-docs.svg'
  },
  'connect-domain': {
    description: 'Connect your domain',
    imageURL: '/s2/vector/domain-name.svg'
  }
};
